/* global jQuery, location */

import { Module } from 'wrapper6'
import { mttAjax } from 'utils/_mtt_ajax'
import GA4Tracking from 'app/GA4/utils/ga4-tracking'

export default class CartHandler extends Module {
  ready () {
    this.setupAccessories()
    this.setupShippingAddress()
    this.setupCartHandling()
    this.setupCartRemove()
  }

  setupAccessories () {
    const jQueryCartForm = jQuery('div.accessories')
    jQueryCartForm.on('click', 'a.accessory_add_to_cart', (e) => {
      this.addToCart(e.target)
    })
  }

  setupShippingAddress () {
    this.shippingCheckbox = document.querySelector('#ship-to-different-address-checkbox')
    if (!this.shippingCheckbox) return
    this.shippingContent = this.shippingCheckbox.parentElement.parentElement.parentElement.querySelector('.shipping_address')

    this.shippingCheckbox.addEventListener('click', (e) => {
      if (this.shippingCheckbox.checked) {
        this.shippingContent.style.display = 'block'
      } else {
        this.shippingContent.style.display = 'none'
      }
    })
  }

  setupCartHandling () {
    jQuery(document).on('click', 'form.woocommerce-cart-form button.minus-qty', (e) => {
      this.handleClick(e.target)
    })

    jQuery(document).on('click', 'form.woocommerce-cart-form button.plus-qty', (e) => {
      this.handleClick(e.target)
    })
  }

  setupCartRemove () {
    jQuery(document).on('click', 'form.woocommerce-cart-form a.remove_product_from_cart_button', (e) => {
      this.handleRemoveClick(e.target)
    })
  }

  /**
   * Add to cart handler.
   * This is triggered when clicked on the "Add to cart" button.
   *
   * @returns {Promise<void>}
   */
  async addToCart (element) {
    this.handleLoader(true)
    const jQueryElement = jQuery(element)

    const input = jQueryElement.parent().parent().find('.postfix-input')

    const data = {
      action: 'add_product_to_cart_by_meter',
      product_id: input.data('product_id'),
      meter: input.val()
    }
    mttAjax('add_product_to_cart_by_meter', data, this.callbackCart.bind(this))
  }

  async handleClick (element) {
    this.handleLoader(true)
    const jQueryElement = jQuery(element)

    const data = {
      action: 'update_product_in_cart',
      cart_item_key: jQueryElement.parent().data('cart_item_key'),
      quantity: jQueryElement.data('type') === 'minus' ? this.getQuantity(element) - 1 : this.getQuantity(element) + 1,
      type: jQueryElement.parent().data('product_type')
    }

    mttAjax('update_product_in_cart', data, this.callbackCart.bind(this))
  }

  async handleRemoveClick (element) {
    this.handleLoader(true)
    const jQueryElement = jQuery(element)

    const data = {
      action: 'remove_product_from_cart',
      cart_item_key: jQueryElement.data('cart_item_key')
    }

    mttAjax('remove_product_from_cart', data, this.callbackCart.bind(this))
  }

  callbackCart (response) {
    if (typeof response !== 'object' || response === null) return console.warn('Response is not a object!')
    if (response.success !== undefined && response.success === true) {
      // GA4
      if (response.data.hasOwnProperty('ga_key') && response.data.hasOwnProperty('ga_item')) {
        GA4Tracking.pushEvent(response.data.ga_key, [response.data.ga_item])
      }

      // location.reload()
      jQuery(document.body).trigger('wc_fragment_refresh')
      jQuery(document.body).on('wc_fragments_refreshed', () => this.handleLoader(false))
      return
    }
    this.handleLoader(false)
  }

  getQuantity (element) {
    const quantityElement = element.closest('.length-picker__quantity-wrap').querySelector('.length-picker__quantity')
    return parseInt(quantityElement.dataset.quantity)
  }

  handleLoader (show) {
    this.body = document.querySelector('body')
    if (show === true) {
      this.body.classList.add('loader')
      this.body.style.display = 'block'
      this.body.style.bottom = 'auto'
      return
    }

    this.body.classList.remove('loader')
    this.body.style.bottom = '0'
  }
}
